/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-array-index-key */
import React, { memo, useState, useCallback, CSSProperties, useEffect } from 'react';
import SingleInput from './SingleInput';
import ConfirmationModal from 'components/confirmation-modal';
import './index.css';
import { getPrimaryMobile } from '__utils/common-utils';
import { SuccessButton } from 'components/button';
import { useForm } from 'react-hook-form';
import useFlashToggler from 'hooks/use-flash-toggler';



export interface OTPInputProps {
    closable?: boolean;
    onCancel?: Function;
    disabled?: boolean;
    style?: CSSProperties;
    className?: string;
    inputStyle?: CSSProperties;
    inputClassName?: string;
    onVerifyOtp: Function;
    onResendOtp: Function;
    submitBtnCTA: string | JSX.Element;
}

export function OTPInputComponent(props: OTPInputProps) {
    const {
        closable,
        onCancel,
        disabled,
        inputClassName,
        inputStyle,
        onVerifyOtp,
        onResendOtp,
        submitBtnCTA,
        ...rest
    } = props;

    const length = 6;
    const [activeInput, setActiveInput] = useState(0);
    const [otpValues, setOTPValues] = useState(Array<string>(length).fill(''));
    const [enteredOTP, setEnteredOTP] = useState<any>();
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(60);
    const flash = useFlashToggler();
    const { handleSubmit } = useForm({ mode: 'onChange' });

    const onChangeOTP = (otpValue: any) => {
        setEnteredOTP(otpValue);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    const handleOtpChange = useCallback(
        (otp: string[]) => {
            const otpValue = otp.join('');
            onChangeOTP(otpValue);
        },
        [onChangeOTP],
    );

    // Helper to return value with the right type: 'text' or 'number'
    const getRightValue = useCallback(
        (str: string) => {
            let changedValue = str;

            if (!changedValue) {
                return changedValue;
            }

            return Number(changedValue) >= 0 ? changedValue : '';
        },
        [true],
    );

    const changeCodeAtFocus = useCallback(
        (str: string) => {
            const updatedOTPValues = [...otpValues];
            updatedOTPValues[activeInput] = str[0] || '';
            setOTPValues(updatedOTPValues);
            handleOtpChange(updatedOTPValues);
        },
        [activeInput, handleOtpChange, otpValues],
    );

    const focusInput = useCallback(
        (inputIndex: number) => {
            const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
            setActiveInput(selectedIndex);
        },
        [length],
    );

    const focusPrevInput = useCallback(() => {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);

    const focusNextInput = useCallback(() => {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);

    // Handle onFocus input
    const handleOnFocus = useCallback(
        (index: number) => () => {
            focusInput(index);
        },
        [focusInput],
    );

    const handleOnChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const val = getRightValue(e.currentTarget.value);
            if (!val) {
                e.preventDefault();
                return;
            }
            changeCodeAtFocus(val);
            focusNextInput();
        },
        [changeCodeAtFocus, focusNextInput, getRightValue],
    );

    const onBlur = useCallback(() => {
        setActiveInput(-1);
    }, []);

    const handleOnKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLInputElement>) => {
            const pressedKey = e.key;

            switch (pressedKey) {
                case 'Backspace':
                case 'Delete': {
                    e.preventDefault();
                    if (otpValues[activeInput]) {
                        changeCodeAtFocus('');
                    } else {
                        focusPrevInput();
                    }
                    break;
                }
                case 'ArrowLeft': {
                    e.preventDefault();
                    focusPrevInput();
                    break;
                }
                case 'ArrowRight': {
                    e.preventDefault();
                    focusNextInput();
                    break;
                }
                default: {
                    if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                        e.preventDefault();
                    }

                    break;
                }
            }
        },
        [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues],
    );

    const handleOnPaste = useCallback(
        (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
            const pastedData = e.clipboardData
                .getData('text/plain')
                .trim()
                .slice(0, length - activeInput)
                .split('');
            if (pastedData) {
                handleOtpChange(pastedData);
                let nextFocusIndex = 0;
                const updatedOTPValues = [...otpValues];
                updatedOTPValues.forEach((val, index) => {
                    if (index >= activeInput) {
                        const changedValue = getRightValue(pastedData.shift() || val);
                        if (changedValue) {
                            updatedOTPValues[index] = changedValue;
                            nextFocusIndex = index;
                        }
                    }
                });
                setOTPValues(updatedOTPValues);
                setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
            }
        },
        [activeInput, getRightValue, length, otpValues],
    );

    const onVerifyOtpSubmit = (data: any) => {
         if (!enteredOTP)
         {
             flash.error("Please enter OTP.");
             
         } else if (enteredOTP?.length !== 6)
         {
             flash.error("Please enter correct OTP.");
 
         } else
         {
             props.onVerifyOtp(enteredOTP);
         }
    }
    return (
        <div {...rest}>
            <ConfirmationModal
                title='Enter OTP'
                isTitleBordered={false}
                closable={false}
                onCancel={onCancel}
                modalBody={
                    <div>
                        <p className='greyTxt'>An OTP has been sent to <b>{getPrimaryMobile()}</b> for verification. </p><br />
                        <form name="otpVerifcationForm" onSubmit={handleSubmit(onVerifyOtpSubmit)}>
                            <div className="otp-group">
                                {Array(6)
                                    .fill('')
                                    .map((_, index) => (
                                        <SingleInput
                                            key={`SingleInput-${index}`}
                                            type='number'
                                            focus={activeInput === index}
                                            value={otpValues && otpValues[index]}
                                            autoFocus
                                            onFocus={handleOnFocus(index)}
                                            onChange={handleOnChange}
                                            onKeyDown={handleOnKeyDown}
                                            onBlur={onBlur}
                                            onPaste={handleOnPaste}
                                            style={inputStyle}
                                            className={inputClassName}
                                            disabled={disabled}
                                        />
                                    ))}
                            </div>
                            <br />

                            <div className="countdown-text">
                                <span>Didn't recieve code ? </span>

                                {seconds > 0 || minutes > 0 ? (
                                    <span>
                                        Resend in: {minutes < 10 ? `0${minutes}` : minutes}:
                                        {seconds < 10 ? `0${seconds}` : seconds}
                                    </span>
                                ) : (
                                    <span className='greenTxt cursorP' onClick={() => {setSeconds(60);setOTPValues(Array(6).fill(''));onResendOtp(enteredOTP)}}>Resend OTP</span>
                                )}


                            </div>
                            <div className='mb24'>
                                <SuccessButton type="submit" disabled={enteredOTP?.length !== 6}>{submitBtnCTA ?? 'Verify OTP'}</SuccessButton>
                            </div>
                        </form>
                    </div>

                }
            />

        </div>
    );
}

const OTPInput = memo(OTPInputComponent);
export default OTPInput;
